import { ModalClose } from "../modalToggle";

document.addEventListener("click", (event: any) => {
  const richMenuChange: HTMLElement = event.target.closest(".js-rich-menu-select")!;
  if (richMenuChange) {
    event.stopPropagation();
    const richMenuInputParent: HTMLElement = richMenuChange.closest(".js-modal-button")!;
    if (richMenuInputParent) {
      const richMenuInput: HTMLInputElement = richMenuInputParent.querySelector(".js-rich-menu-radio")!
      console.log(richMenuInput);
      richMenuInput.checked = true;
      ModalClose();
    }
  }
})
